import { PreviewConfig } from '../types/preview-config';

export const PREVIEWS_CONFIG: Record<string, Record<string, PreviewConfig>> = {
  CONVERSION: {
    google: {
      variants: ['1', '2', '3', '4', '5'],
      videoResolutions: ['1080x1080', '1080x1920', '1920x1080'],
      imageResolutions: ['1080x1920', '1200x1200', '1200x628', '960x1200'],
      maxLines: {
        '1': 3,
        '2': 3,
        '3': 4,
        '4': 3,
        '5': 3
      }
    },
    meta: {
      variants: ['1'],
      videoResolutions: ['9:16'],
      imageResolutions: ['1:1', '4:5'],
      maxLines: {
        '1': 3
      }
    }
  },
  CONSIDERACION: {
    google: {
      variants: ['1'],
      videoResolutions: ['1080x1080', '1080x1920', '1920x1080'],
      imageResolutions: ['1080x1920', '1200x1200', '1200x628', '960x1200'],
      maxLines: {
        '1': 3
      }
    },
    meta: {
      variants: ['1'],
      videoResolutions: ['9:16'],
      imageResolutions: ['1:1', '4:5'],
      maxLines: {
        '1': 3
      }
    }
  },
  AWARENESS: {
    meta: {
      variants: ['1'],
      videoResolutions: ['9:16'],
      imageResolutions: ['1:1', '4:5'],
      maxLines: {
        '1': 4
      }
    }
  }
};
